import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import i18n from '../../../../../i18n';
import _ from 'lodash';
import Button from 'react-bootstrap/Button';
import BzmIcon from '../../../../../components/icons/BzmIcon';

interface ProxySettingProps {
  isReadOnly: boolean;
  value: string;
  onChange: (event: any) => void;
  onRemove: () => void;
}

/**
 * This component is going to be deprecated.
 * @param props
 * @constructor
 */
const ProxySetting = (props: ProxySettingProps) => {
  const [isDisabled, setIsDisabled] = useState(_.isNil(props.value) || _.isEmpty(props.value));
  return (
    <>
      {isDisabled && (
        <div>
          <p>There is no Proxy Setting defined.</p>

          <Button
            onClick={() => {
              setIsDisabled(false);
            }}
            className="btn btn-primary btn-circular"
            title={'Add Proxy Settings'}
          >
            <BzmIcon variant={'icon-bzm-add'} />
          </Button>
        </div>
      )}

      {!isDisabled && (
        <div className={'card'}>
          <div className="card-body">
            <Form.Group controlId="qa-input-proxy-url">
              <Form.Label>{i18n.t('transactions:editor.proxyUrl')}</Form.Label>
              <Form.Control
                disabled={props.isReadOnly}
                value={props.value}
                type="text"
                name="proxyUrl"
                onChange={props.onChange}
                placeholder={i18n.t('transactions:editor.proxyUrl')}
              />
            </Form.Group>

            {/* Footer */}
            <div className={'text-right mt-4'}>
              <Button
                onClick={() => {
                  props.onRemove();
                  setIsDisabled(true);
                }}
                className="btn btn-danger btn-circular"
                title={'Remove Proxy Settings'}
              >
                <BzmIcon variant={'icon-bzm-delete'} />
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProxySetting;
